var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocaliser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1757554047012,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1913,
    width: 16,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M863.085714 0H160.914286C73.142857 0 0 73.142857 0 168.228571v526.628572c0 95.085714 73.142857 168.228571 160.914286 168.228571h702.171428c87.771429 0 160.914286-73.142857 160.914286-168.228571V168.228571C1024 73.142857 950.857143 0 863.085714 0zM950.857143 694.857143c0 51.2-43.885714 95.085714-87.771429 95.085714H160.914286c-51.2 0-87.771429-43.885714-87.771429-95.085714V168.228571C73.142857 117.028571 109.714286 73.142857 160.914286 73.142857h702.171428c51.2 0 87.771429 43.885714 87.771429 95.085714v526.628572z m-43.885714 292.571428c0 21.942857-14.628571 36.571429-36.571429 36.571429H146.285714c-21.942857 0-36.571429-14.628571-36.571428-36.571429 7.314286-21.942857 21.942857-36.571429 36.571428-36.571428h724.114286c21.942857 0 36.571429 14.628571 36.571429 36.571428z",
    fill: "#8a8a8a",
    "p-id": 1914
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219.428571 548.571429c-7.314286 0-21.942857-7.314286-29.257142-14.628572-14.628571-14.628571-14.628571-36.571429 0-51.2l219.428571-190.171428c7.314286-7.314286 21.942857-7.314286 29.257143-7.314286 7.314286 0 21.942857 7.314286 21.942857 14.628571l102.4 160.914286 219.428571-168.228571c14.628571-14.628571 36.571429-7.314286 51.2 7.314285 14.628571 14.628571 7.314286 36.571429-7.314285 51.2L585.142857 541.257143c-7.314286 7.314286-14.628571 7.314286-29.257143 7.314286-7.314286 0-21.942857-7.314286-21.942857-14.628572L431.542857 373.028571 241.371429 541.257143c-7.314286 7.314286-14.628571 7.314286-21.942858 7.314286z",
    fill: "#8a8a8a",
    "p-id": 1915
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocaliser);
export default __webpack_public_path__ + "static/media/Localiser.f14815a7fb7dabf82deadcc8c84c3db8.svg";
export { ForwardRef as ReactComponent };